export default __webpack_public_path__ + "static/media/emerald.adf6457d.svg";